import {
  Formik,
  FormConfig,
  FormSectionKinds,
  fulls
} from "components/FormFactory"
import { GridProps } from "@material-ui/core/Grid"
import CityAutocomplete from "components/autocomplete/CityAutocomplete"
import CompanyAutocomplete from "components/autocomplete/CompanyAutocomplete"
import BasinAutocomplete from "components/autocomplete/BasinAutocomplete"

const grid: GridProps = {
  xs: 12,
  md: 6
}

const sections: FormConfig = [
  {
    kind: FormSectionKinds.Flat,
    grid: fulls,
    contentGrid: true,
    header: "",
    fields: [
      {
        name: "name",
        label: "Well Name",
        type: Formik.Text,
        grid: fulls,
        props: {
          id: "well-name",
          autoFocus: true
        }
      },
      {
        name: "apiNumber",
        label: "API Number",
        type: Formik.Text,
        grid: fulls,
        props: {
          id: "api-number"
        }
      },
      {
        name: "country.name",
        label: "Country",
        type: Formik.Text,
        grid,
        props: {
          id: "country",
          disabled: true
        }
      },
      {
        name: "basin",
        label: "Basin",
        grid,
        type: Formik.Autocomplete,
        props: {
          id: "well-basin",
          AutocompleteComponent: BasinAutocomplete,
          size: "medium"
        }
      },
      {
        name: "city",
        label: "City",
        grid,
        type: Formik.Autocomplete,
        props: {
          id: "well-city",
          AutocompleteComponent: CityAutocomplete,
          size: "medium"
        }
      },
      {
        name: "company",
        label: "Company",
        grid,
        type: Formik.Autocomplete,
        props: {
          id: "well-company",
          AutocompleteComponent: CompanyAutocomplete,
          size: `medium`
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        grid,
        type: Formik.Text,
        props: {
          id: "latitude",
          type: "number"
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        grid,
        type: Formik.Text,
        props: {
          id: "longitude",
          type: "number"
        }
      },
      {
        name: "directions",
        label: "Directions to Location",
        grid: { xs: 12 },
        type: Formik.Text,
        props: {
          id: "directions",
          multiline: true,
          rows: 3,
          placeholder: "Directions to well location, streets to take, etc."
        }
      }
    ]
  }
]

export default sections
